module.exports = __webpack_public_path__ + "img/vue2-lacet_rouge.fa4d2b10.png";